import pick from "lodash/pick"

export const getTripEditModalProps = (data) => {
  const tripGeneral = [
    "id",
    "name",
    "code",
    "startDate",
    "endDate",
    "destinations",
    "image",

    "organisation",
    "legal",
    "payment",
  ]

  const _data = data

  return {
    ..._data,
    startDate: _data?.startDate?.split("T", 1)[0],
    endDate: _data?.endDate?.split("T", 1)[0],
    destinations: _data?.destinations?.map((_) => ({
      label: _?.name,
      value: { ..._ },
    })),
    // organisation: {
    agency: {
      label: _data?.agency?.name,
      value: { ..._data?.agency },
    },
    agents: _data?.agents?.map((_) => ({
      label: _?.displayName,
      value: { ..._ },
    })),
    leaders: _data?.leaders?.map((_) => ({
      label: _?.displayName,
      value: { ..._ },
    })),
    // },

    payment: {
      ..._data?.payment,
      deposits: _data?.payment?.deposits?.map((_) => ({
        ..._,
        dueDate: _.dueDate?.split("T", 1)[0],
      })),
    },

    legal: {
      ..._data.legal,
      contract: {
        label: _data?.legal?.contract?.name,
        value: {
          ..._data?.legal?.contract,
        },
      },
    },
  }
}
